export default __webpack_public_path__ + "static/media/spark_28.cacc8adb.png";